



































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
  import { outgoingInvoiceApi } from '@/services/st-api';
  import { OutgoingInvoiceTimeEntryModel, StSelectListItem, TimeEntryFilter, TimeEntryFilterTimeFrame } from '@/services/api/nswag/stapiclient_generated';
  import TimeEntryFilterComponent from '@/components/timeentry-filter/TimeEntryFilterComponent.vue';
  import { UserStore } from '@/store/user-module';
  import {
    IOutgoingInvoicePlaceholders
  } from "@/views/OutgoingInvoice/outgoing-invoice-helper";
  import { DateTime } from "luxon";
import { DtFromIso, formatDate } from "@/utlitities/helper";

  @Component({
    components: {
      TimeEntryFilterComponent,
    },
  })
  export default class OutgoingInvoiceTimeEntries extends Vue {
    @Prop() customerId!: number;
    @Prop() filterJson!: string;
    customers: StSelectListItem[] = [];
    timeEntries: OutgoingInvoiceTimeEntryModel[] = [];
    @Prop() value!: number[];
    @Prop() invoiceId!: number;

    timeEntryFilter: TimeEntryFilter = TimeEntryFilter.fromJS({ customerIds: [], timeframe: TimeEntryFilterTimeFrame.LastMonth });

    overwriteChangedInvoice: boolean = false;
    customerWatch: any;

    loading = false;
    delayLoading = false;
    filterLoading = false;

    async mounted() {
      try {
        this.loading = true;
        if (this.filterJson) {
          this.timeEntryFilter = TimeEntryFilter.fromJS(JSON.parse(this.filterJson));
          this.$emit('filterChanged', this.timeEntryFilter);
        } else {
          await this.customerIdChanged();
        }

        this.customerWatch = this.$watch('customerId', async () => {
          await this.customerIdChanged();
        });
      } finally {
        this.loading = false;
      }
    }

    beforeDestroy() {
      this.customerWatch();
    }

    async customerIdChanged() {
      try {
        this.loading = true;
        this.timeEntryFilter.timeframe = TimeEntryFilterTimeFrame.LastMonth;
        this.timeEntryFilter.entryDateFrom = UserStore.userNowDateTime.minus({ months: 1 }).startOf('month').toISODate();
        this.timeEntryFilter.entryDateTo = UserStore.userNowDateTime.minus({ months: 1 }).endOf('month').toISODate();
        this.timeEntryFilter.customerIds = [this.customerId];
        this.$emit('filterChanged', this.timeEntryFilter);
        this.$emit('placeholdersChanged', this.placeholders);
      } finally {
        this.loading = false;
      }
    }

    get showChangeWarning() {
      return !!this.invoiceId && !this.overwriteChangedInvoice;
    }

    get currency() {
      return UserStore.userSettings.currency;
    }

    // entryIsDisabled() {}

    get placeholders(){
      return {
        DateFrom: formatDate(this.timeEntryFilter.entryDateFrom),
        DateTo: formatDate(this.timeEntryFilter.entryDateTo)
      } as IOutgoingInvoicePlaceholders;
    }

    async loadTimeEntries() {
      this.timeEntries = await outgoingInvoiceApi.getOutgoingInvoiceTimeEntries(this.invoiceId, this.timeEntryFilter);
    }

    private multiTimeout: any;
    async applyFilter() {

      if (this.filterLoading) {
        return;
      }

      if (this.multiTimeout) {
        clearTimeout(this.multiTimeout);
      }

      this.multiTimeout = setTimeout(async () => {
        try {
          this.loading = true;
          this.$emit('filterChanged', this.timeEntryFilter);
          await this.$nextTick();
          this.$emit('placeholdersChanged', this.placeholders);
          await this.loadTimeEntries();
        } finally {
          this.loading = false;
        }
      }, 20);
    }

    get selectedTimeEntries(){
      return this.timeEntries.filter(x=>this.entrySelected(x));
    }

    get selectedTimeEntryIds() {
      return this.value;
    }

    set selectedTimeEntryIds(data: number[]) {
      this.$emit('input', data);
    }

    get anyEntrySelected() {
      return this.selectedTimeEntryIds?.length;
    }

    toggleAllEntries() {
      if (this.anyEntrySelected) {
        this.selectedTimeEntryIds = [];
      } else {
        this.selectedTimeEntryIds = this.timeEntries?.filter((x) => !x.isDisabled)?.map((x) => x?.id ?? 0);
      }
    }

    entrySelected(entry: OutgoingInvoiceTimeEntryModel) {
      return this.selectedTimeEntryIds.some((x) => x == entry.id);
    }

    toggleEntry(entry: OutgoingInvoiceTimeEntryModel) {
      if (entry.isDisabled) {
        return;
      }
      if (this.entrySelected(entry)) {
        this.selectedTimeEntryIds = this.selectedTimeEntryIds.filter((x) => x != entry.id);
      } else {
        this.selectedTimeEntryIds = [...this.selectedTimeEntryIds, entry.id ?? 0];
      }
    }
  }
